(function (blz, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    blz.generic = blz.generic || {};
    blz.generic.url = factory();
  }
})((window.blz = window.blz || {}), function () {
  'use strict';

  var URL = {
    decode: function (s) {
      var pl = /\+/g;
      return decodeURIComponent((s || '').replace(pl, ' '));
    },

    search: function (path) {
      path = path || location.search;

      if (path && typeof path !== 'string') {
        return;
      }

      var match;
      var urlParams = {};
      var search = /([^&=]+)=?([^&]*)/g;

      if (path.charAt(0) == '?' || path.charAt(0) == '&') {
        path = path.substring(1);
      }

      while ((match = search.exec(path))) {
        urlParams[URL.decode(match[1])] = URL.decode(match[2]);
      }

      return urlParams;
    }
  };

  return URL;
});
